import React from 'react'
import bimal_sir from './bimal_sir.jpg'
import Rajeev from './Rajeev_sir.jpg'
import fabrizio_sir from './fabrizio.baiardi.jpg'
import muhmmad_sir from './muhammad_sir.png'
import pascal_sir from './Pascal_sir.png'
import Mathapati_sir from './mathapati_sir.jpg'
import Ashok_sir from './Ashok_sir.png'
import Doja_sir from './M.N_doja_sir.jpg'
import gadadhar_sir from './gadadhar.png'
import Sehzad_sir from './Sehzad_sir.png'
import Sanjay from './sanjay.jpg'
import indranath from './indranath.png'

function Speakers() {

    const speaker= [

    {
      proffessor: "Prof. Bimal Kumar Roy",
      designation: "Professor",
      University: "Indian Statistical Institute ",
      State: " Kolkata",
      description: "Prof. Bimal Kumar Roy is a researcher of international standing. His primary research interest involves all aspects of Statistics and its applications. ",
      profile: "https://www.isical.ac.in/~bimal/",
      Country: "India",
      image: bimal_sir
    },

    {
      proffessor: "Prof. Rajeev Tripathi",
      designation: "Vice Chancellor",
      University: " Rajiv Gandhi Proudyogiki Vishwavidyalaya",
      State: "Madhya Pradesh",
      description: "Prof. Rajeev Tripathi received his B.Tech from the University of Allahabad in 1986, M. Tech in 1992 and PhD in 1998. He became a faculty member at MNNIT Allahabad in 1988 and has been a professor since 2005. From 2002 to 2004, he was professor in St. Augustine in Trinidad (WI) at the University of the West Indies.",
      profile: "https://www.rgpv.ac.in/pdf/Brief_Profile_Prof_Rajeev_Tripathi.pdf",
      Country: "India",
      image: Rajeev
    },

    {
      proffessor: "Prof. Fabrizio Baiardi",
      designation: "Professor",
      University: "University of Pisa",
      State: "Pisa",
      description: "Fabrizio Baiardi graduated in Computer Science at Università di Pisa where is a Full Professor with Dipartimento di Informatica where he has chaired the degree on security of ICT infrastructures. His main research interests in the computer security field are formal approaches to risk assessment and management of complex ICT infrastructures",
      profile: "https://ieeexplore.ieee.org/author/37295702700",
      Country: "Italy",
      image: fabrizio_sir
    },


  
    {
      proffessor: "Prof. Muhammad Khurram Khan",
      designation: "Professor",
      University: "King Saud University",
      State: "Kanpur",
      description: "Prof. Muhammad Khurram Khan is a global thought leader and influencer in cybersecurity. He is a Professor of Cybersecurity at the Center of Excellence in Information Assurance (CoEIA), King Saud University, Kingdom of Saudi Arabia.",
      profile: "https://www.professorkhurram.com/",
      Country: "Saudi Arabia.",
      image: muhmmad_sir
    },

    

    // {
    //   proffessor: "Prof. Pascal LORENZ",
    //   designation: "Professor",
    //   University: "University of Haute Alsace ",
    //   State:"CA",
    //   description:"Pascal Lorenz (lorenz@ieee.org) received his M.Sc. (1990) and Ph.D. (1994) from the University of Nancy, France. Between 1990 and 1995 he was a research engineer at WorldFIP Europe and at Alcatel-Alsthom.",
    //   Country: " France",
    //   profile: "http://grtc.uha.fr/lorenz.html",
    //   image: pascal_sir
    // },

    {
      proffessor: "Prof. Shivakumar Mathapathi",
      designation: "Professor",
      University: "UC San Diego Extn ",
      State:"CA",
      description:"Shivakumar Mathapathi is an adjunct faculty member at Northeastern University as well at UC San Diego, Extension; he is also teaching at regional community academia including ethnically diverse institutions such as Ohlone and De-Anza College in California.",
      profile: "https://www.khoury.northeastern.edu/people/shivakumar-mathapathi/",
      Country: "USA",
      image: Mathapati_sir
    },

    {
      proffessor: "Prof. Ashok Kumar Das",
      designation: "Professor",
      University: "Indian Institute of Information Technology, Hyderabad",
      State: " Telegana",
      description: "Prof. Ashok Kumar Das currently working as a full Professor effective from 1 January 2023 in the Center for Security, Theory and Algorithmic Research (Department of Computer Science and Engineering) of the International Institute of Information Technology (IIIT), Hyderabad, India.",
      profile: "https://www.iiit.ac.in/faculty/ashok-kumar-das/",
      Country: "India",
      image: Ashok_sir
    },

    // {
    //   proffessor: "Prof. M.N. Doja",
    //   designation: "Honourable Director",
    //   University: "Indian Institute of Information Technology ",
    //   State: " Sonepat",
    //   description:"Prof(Dr) Shri M.N. Doja joined as Director of Indian Institute of Information Technology, Sonepat in 2019. Along with being the Director of IIIT Sonepat, Dr. M.N. Doja is Professor in the Department of Computer Engineering, Faculty of Engineering and Technology, Jamia Millia Islamia, New Delhi-110025.",
    //   profile: "https://iiitsonepat.ac.in/director-s-profile",
    //   Country: "India",
    //   image: Doja_sir
    // },

    {
      proffessor: "Prof. Gadadhar Misra",
      designation: "Professor",
      University: "Indian Institute of Technology, Gandhinagar",
      State: "Gujarat",
      description: "Gadadhar Misra obtained his BSc from Utkal University (1977), MSc in Mathematics from Sambalpur University (1979), and PhD from SUNY, Stony Brook (1982). He served as Assistant Professor at the University of Georgia, Athens (1982-84), and the University of California, Irvine (1984-85), then at the Indian Statistical Institute (ISI) (1986-89). He became Associate Professor (1989-93) and then Professor at ISI, Bangalore (1993-2007). He joined the Indian Institute of Science, Bangalore as a Professor in 2007 and is currently a visiting professor at IIT Gandhinagar.",
      profile: "https://iitgn.ac.in/faculty/maths/fac-gadadhar",
      Country: "India",
      image: gadadhar_sir
    },

    // {
    //   proffessor: "Prof. Shehzad Ashraf Chaudhry",
    //   designation: "Professor",
    //   University: "Abu Dhabi University (ADU)",
    //   State: "Dehradun",
    //   description: "Shehzad Ashraf Chaudhry (Member, IEEE) received the M.S. and Ph.D. degrees (with distinction) in computer science from the International Islamic University, Islamabad, Pakistan, in 2009 and 2016, respectively.,He is currently an Associate Professor of Cybersecurity Engineering with the Department of Computer Science and Information Technology, College of Engineering, Abu Dhabi University, Abu Dhabi, UAE.",
    //   profile: "https://ieeexplore.ieee.org/author/38243873600",
    //   Country: "UAE",
    //   image: Sehzad_sir
    // },

  
    {
      proffessor: "Prof. Sanjay Jasola",
      designation: "Vice Chancellor",
      University: "DBS Global University",
      State: "Dehradun",
      description:"Prof. (Dr.) Sanjay Jasola currently serves as the Vice Chancellor at DBS Global University in Dehradun. Previously, he held the position of founding Vice Chancellor at Graphic Era Hill University for four terms, spanning more than 12 years. Prof. Jasola has also served as Dean (Academics) and Dean (School of ICT) at Gautam Buddha University in Greater Noida. With over three decades of experience in teaching, research, and academic administration, he has a rich background in education. He has been a faculty member at Wawasan Open University in Penang, Malaysia, and held the role of Deputy Director at IGNOU in New Delhi.",
      profile: "https://dgu.ac/faculties/dbsgu/prof-dr-sanjay-jasola/",
      Country: "India",
      image: Sanjay
    },
    {
      proffessor: "Dr. Indranath Chatterjee",
      designation: "Associate Professor",
      University: "Manchester Metropolitan University",
      State: "Manchester",
      description:"Dr. Indranath Chatterjee is working as an Associate Professor in the Department of Computer and Mathematics at Manchester Metropolitan University, Manchester, UK. Currently, he is also attached to Woxsen University, India, Chitkara University, India and Mody University, India as Adjunct Professor, and as a Collaborating Faculty at the International Center for Neuroscience Research, Georgia. He also holds the position of AI Research Consultant at Korea Aerospace University, South Korea and as a General Director (International Collaborations) of The Korea Multimedia Society (KMMS), South Korea.",
      profile: "https://www.mmu.ac.uk/staff/profile/dr-indranath-chatterjee",
      Country: "United Kingdom",
      image: indranath
    }
    
  ]
  return (
    <div className="container">
        <h1 className="text-danger text-center"><strong>Keynote Speakers</strong></h1>

        <div class="row row-cols-1 row-cols-md-3 g-4 my-4">
        {speaker.map((e,index)=>(
        <div className="col" key={index}>
          <div className="card text-center h-100 shadow-lg">
            <img key={index} src={e.image} className="card-img-top rounded-circle mx-auto d-block my-3" alt="..." style={{height:"50%", width:"50%",borderRadius:"50%"}} />
            <div className="card-body">
              <h5 className="card-title">{e.proffessor}</h5>
              <p className="card-text">{e.designation}</p>
              <p className="card-text">{e.University}</p>
              <p className="card-text">{e.Country}</p>
              <p className="card-text" style={{textAlign:"justify"}}>{e.description.slice(0,200)}.....</p>
              <a type="button" className="btn btn-outline-danger" href={e.profile} target="_blank">Visit Profile</a>
            </div>
          </div>
        </div>
        ))}
        
        
        
        </div>
    </div>
  )
}

export default Speakers